const CURRENCY_ALIAS_MAP = {
    pound: 'GBP',
    pounds: 'GBP',
    dollar: 'USD',
    dollars: 'USD',
    euro: 'EUR',
    euros: 'EUR',
    yen: 'JPY',
};

function normalizeCurrencyCode(currency) {
    if (!currency) return undefined;
    const uppercased = currency.toUpperCase();
    const alias = CURRENCY_ALIAS_MAP[currency.toLowerCase()];
    if (alias) return alias;
    if (uppercased.length === 3) return uppercased;
    return undefined;
}

export function formatSalary(salary, currency){
    try {
        const normalizedCurrency = normalizeCurrencyCode(currency);
        if(normalizedCurrency) {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: normalizedCurrency, currencyDisplay: 'code' }).format(salary);
        }
        return new Intl.NumberFormat('en-US').format(salary);
    } catch (e) {
        return new Intl.NumberFormat('en-US').format(salary);
    }
}

function getOS() {
    var userAgent = window.navigator.userAgent,
        platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;
  
    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (/Linux/.test(platform)) {
      os = 'Linux';
    }
  
    return os;
  }

  export function deviceIsPhoneOrTablet(){
    return getOS() === 'Android' || getOS() === 'iOS';
  }

export function getBaseUrl(port = 8000) {
  const origin = window.location.origin;
  const elayIoRegex = /^https?:\/\/([a-z0-9-]+\.)*elay\.io/i;

  if (origin.includes('localhost')) return `http://localhost:${port}`;
  else if (origin.includes('127.0.0.1')) return `http://127.0.0.1:${port}`;
  else if (elayIoRegex.test(origin)) return origin;

  return 'https://app.elay.io';
}
